import { inject, Injectable, NgZone } from '@angular/core'
import { SimpleWindowRefService } from '../window/simple-window-ref.service'

/**
 * Subset of Elevio's JavaScript API that we tend to use.
 * @see https://api-docs.elevio.help/en
 */
export interface ElevioApi {
  openHome: () => void
  openArticle: (articleId: string) => void
}

export interface WithElevio {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Elevio's global API name
  _elev?: ElevioApi
}

@Injectable({ providedIn: 'root' })
export class ElevioService {
  private readonly windowRef = inject(SimpleWindowRefService)
  private readonly ngZone = inject(NgZone)

  openHome(): void {
    this.withElevio(elevio => elevio.openHome())
  }

  openArticle(articleId: string): void {
    this.withElevio(elevio => elevio.openArticle(articleId))
  }

  // adblockers can block the widget script, in which case this will return false
  isWidgetAvailable(): boolean {
    return !!this.getElevioApi()
  }

  private getElevioApi(): ElevioApi | undefined {
    return (this.windowRef.nativeWindow() as WithElevio)._elev
  }

  private withElevio(action: (elevio: ElevioApi) => void): void {
    const elevio = this.getElevioApi()
    if (elevio) {
      this.ngZone.runOutsideAngular(() => action(elevio))
    }
  }
}
